import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Tv, Volume2 } from "lucide-react";
import { MirrorReceiver } from "@/lib/mirrorRtc";

export default function MirrorTv() {
  const [params] = useSearchParams();
  const [code, setCode] = useState(params.get("code") || "");
  const [state, setState] = useState("waiting");
  const [who, setWho] = useState("");
  const [info, setInfo] = useState(null);
  const [muted, setMuted] = useState(true);
  const vid = useRef(null);
  useEffect(() => {
    document.title = "Jixxeo Mirroring · TV";
    const r = new MirrorReceiver(params.get("code"), (t, a) => {
      if (t === "code") setCode(a);
      if (t === "paired") { setWho(a); setState("paired"); }
      if (t === "info") setInfo(a);
      if (t === "stream" && vid.current) { vid.current.srcObject = a; vid.current.play().catch(() => {}); setState("live"); }
      if (t === "stopped") { setState("waiting"); setInfo(null); if (vid.current) vid.current.srcObject = null; }
    });
    r.connect();
    return () => r.destroy();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const host = window.location.host;
  return (
    <div className="fixed inset-0 bg-black text-white flex items-center justify-center" style={{ fontFamily: "'Outfit',ui-sans-serif" }} data-testid="mirror-tv" data-state={state}>
      <video ref={vid} autoPlay playsInline muted={muted} className={`absolute inset-0 w-full h-full object-contain ${state === "live" ? "" : "hidden"}`} data-testid="mirror-tv-video" />
      {state === "live" && muted && <button onClick={() => setMuted(false)} data-testid="mirror-tv-unmute" className="absolute bottom-6 right-6 bg-white/15 backdrop-blur rounded-full px-5 py-3 flex items-center gap-2 font-bold"><Volume2 className="w-5 h-5" /> Sound on</button>}
      {state !== "live" && (
        <div className="text-center px-6">
          <Tv className="w-16 h-16 mx-auto text-[#00F0FF]" />
          <div className="font-heading font-black text-3xl md:text-5xl mt-4">Jixxeo <span className="text-[#00F0FF]">Mirroring</span> TV</div>
          {state === "paired" ? <p className="text-white/70 mt-6 text-xl" data-testid="mirror-tv-paired">Connected to <b>{who}</b>. {info?.label ? `Starting ${info.label}…` : "Pick something to cast on your device."}</p> : <>
            <p className="text-white/60 mt-6 text-lg md:text-xl">On your phone or laptop open <b className="text-white">{host}/mirror</b> and enter</p>
            <div className="mono font-black text-6xl md:text-8xl tracking-[0.3em] mt-5 text-[#39FF14]" data-testid="mirror-tv-code">{code || "······"}</div>
            <p className="text-white/40 mt-6 text-sm">Keep this page open. Both devices need an internet connection — same Wi-Fi gives the best quality.</p>
          </>}
        </div>
      )}
    </div>
  );
}
